<template>
  <div>
    <transition-group name="list">
      <div class="card" v-for="(item, index) in newCardList" :key="item.id" @click="handleGoInfo(item)">
        <div class="top">
          <!-- <div class="no" v-if="item.exceptionInfo != '0' && item.exceptionInfo != null">异</div>
          <div class="ok" v-else>验</div> -->
          <div class="no" v-if="item.invoiceSource === 1">异</div>
          <div class="no" v-else-if="item.checkFlag === 0">未</div>
          <div class="ok" v-else-if="item.checkFlag === 1 || item.checkFlag === 4">验</div>
          <div v-else class="ok">验</div>
          <div :class="['type', getColor(item.invoiceType)]">{{getType(item.invoiceType)}}</div>
          <div class="seller-name">{{getTitle(item)}}</div>
          <div class="tick">
            <div v-if="Number(item.reimbursementFlag) === 0 && item.invoiceSource !== 1 || getSelectInvoice(item)" :class="['tick-no', 'huisuiyunfont', item.flag ? 'tick-ok': '']" @click.stop="handleSelect(item, index)">{{'\ue639'}}</div>
            <div v-else-if="Number(item.reimbursementFlag) === 2" class="reim">
              <span class="icon huisuiyunfont">{{'\ue66d'}}</span>
              <span class="font-w">已完成</span>
            </div>
            <div v-else-if="Number(item.reimbursementFlag) === 1" class="reim padding">
              <span class="icon huisuiyunfont">{{'\ue66e'}}</span>
              <span class="font-w">待审批</span>
            </div>
            <div v-else-if="Number(item.reimbursementFlag) === 3" class="reim back">
              <span class="icon huisuiyunfont">{{'\ue66c'}}</span>
              <span class="font-w">已驳回</span>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="time">{{item.drewDate}}</div>
          <div class="division-line"></div>
          <div class="first-goods-name" v-if="item.invoiceType === '207'">{{ item.mileage+'km'}}</div>
          <div class="first-goods-name" v-else-if="(item.invoiceType === '202')">{{item.agentCode}}</div>
          <div class="first-goods-name" v-else-if="(item.invoiceType === '201')">{{item.trainNumber}}</div>
          <div class="first-goods-name" v-else>{{item.firstGoodsName ? item.firstGoodsName : '--'}}</div>
          <div class="money">
            <div>{{Number(item.amountWithTax).toFixed(2)}}</div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
import { getInvoiceType, getInvoiceColor, isSameByInvoiceCode } from '@utils/basicUtil'
export default {
  props: {
    cardList: {
      type: Array,
      default: () => []
    },
    handleGetCardLenght: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      newCardList: [],
      selectList: [],
      oldSelCardList: []
    }
  },
  watch: {
    cardList (v) {
      this.newCardList = v
    }
  },
  mounted () {
    this.initCard()
    this.callBack()
  },
  activated () {
    this.initCard()
  },
  computed: {
    getTitle () {
      return (item) => {
        if (item.sellerName) {
          return item.sellerName
        } else if (item.invoiceType === '200') {
          return '国家税务局通用定额发票'
        } else if (item.invoiceType === '202') {
          return item.issueBy
        } else if (item.invoiceType === '51' || item.invoiceType === '61') {
          return item.purchaserName
        } else if (item.place) {
          return item.place
        } else {
          return item.stationGetOn + ' - ' + item.stationGetOff
        }
      }
    },
    getType () {
      return (item) => {
        return getInvoiceType(item)
      }
    },
    getColor () {
      return (item) => {
        return getInvoiceColor(item)
      }
    }
  },
  methods: {
    getSelectInvoice (item) {
      let oldSelCardList = []
      if (sessionStorage.oldSelCardList) {
        oldSelCardList = JSON.parse(sessionStorage.oldSelCardList)
      }
      if (oldSelCardList.find(i => isSameByInvoiceCode(i, item))) {
        return true
      }
      return false
    },
    initCard () {
      if (sessionStorage.selCardList) {
        this.selectList = JSON.parse(sessionStorage.selCardList)
      } else {
        this.selectList = []
      }
      if (sessionStorage.oldSelCardList) {
        this.oldSelCardList = JSON.parse(sessionStorage.oldSelCardList)
      } else {
        this.oldSelCardList = []
      }
    },
    callBack () {
      if (!sessionStorage.selCardList) { return }
      let sum = 0
      this.selectList.forEach(item => {
        sum += Number(item.amountWithTax)
      })
      this.handleGetCardLenght(this.selectList.length, sum)
    },
    handleSelect (item, index) {
      if (sessionStorage.selCardList) {
        this.selectList = JSON.parse(sessionStorage.selCardList)
      }
      let newItem
      if (item.flag) {
        newItem = { ...item, flag: false }
        this.selectList = this.selectList.filter(i => {
          return !isSameByInvoiceCode(i, item)
        })
      } else {
        // 重新勾选的时候如果存在历史勾选数据，需要用历史的勾选数据，因为个人票夹重选的数据与报销的id不一致
        const oldItem = this.oldSelCardList.find(i => isSameByInvoiceCode(i, item))
        newItem = { ...item, flag: true }
        if (oldItem) {
          // 将报销数据存入勾选数据中
          this.selectList.push({ ...oldItem, flag: true })
        } else {
          // 正常流程
          this.selectList.push(newItem)
        }
      }
      // 保存的永远是票夹的数据
      this.newCardList.splice(index, 1, newItem)
      sessionStorage.selCardList = JSON.stringify(this.selectList)
      sessionStorage.cardList = JSON.stringify(this.newCardList)
      this.callBack()
    },
    handleGoInfo (item) {
      switch (item.invoiceType) {
        case '199':
          this.$router.push({
            path: '/normed/index',
            query: { id: item.id, type: '199', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '201':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '201', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '202':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '202', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '207':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '207', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '200':
          this.$router.push({
            path: '/normed/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, no: item.invoiceNo }
          })
          break
        case '51':
          this.$router.push({
            path: '/electricity-travel/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
        case '61':
          this.$router.push({
            path: '/electricity-travel/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
        default:
          this.$router.push({
            path: '/electricity/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
      }
    }
  }
}
</script>
<style scoped src="./style.less" lang="less"></style>
